var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonalDetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.05716 16.1576C3.18238 15.0324 4.70851 14.4002 6.2998 14.4002H14.6998C16.2911 14.4002 17.8172 15.0324 18.9424 16.1576C20.0677 17.2828 20.6998 18.8089 20.6998 20.4002V22.8002C20.6998 23.463 20.1625 24.0002 19.4998 24.0002C18.8371 24.0002 18.2998 23.463 18.2998 22.8002V20.4002C18.2998 19.4455 17.9205 18.5298 17.2454 17.8547C16.5703 17.1795 15.6546 16.8002 14.6998 16.8002H6.2998C5.34503 16.8002 4.42935 17.1795 3.75422 17.8547C3.07909 18.5298 2.6998 19.4455 2.6998 20.4002V22.8002C2.6998 23.463 2.16255 24.0002 1.4998 24.0002C0.837063 24.0002 0.299805 23.463 0.299805 22.8002V20.4002C0.299805 18.8089 0.931946 17.2828 2.05716 16.1576Z",
    fill: "#2A184B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4998 2.40024C8.51158 2.40024 6.89981 4.01202 6.89981 6.00024C6.89981 7.98847 8.51158 9.60024 10.4998 9.60024C12.488 9.60024 14.0998 7.98847 14.0998 6.00024C14.0998 4.01202 12.488 2.40024 10.4998 2.40024ZM4.4998 6.00024C4.4998 2.68654 7.1861 0.000244141 10.4998 0.000244141C13.8135 0.000244141 16.4998 2.68654 16.4998 6.00024C16.4998 9.31395 13.8135 12.0002 10.4998 12.0002C7.1861 12.0002 4.4998 9.31395 4.4998 6.00024Z",
    fill: "#2A184B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalDetails);
export default __webpack_public_path__ + "static/media/personal-details.1d1070e5.svg";
export { ForwardRef as ReactComponent };